module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point02_03_miyakoblue-1e0d752ee2bf7cff0753011466018983.jpg";